export default __webpack_public_path__ + "static/crusader_frame_account_bg-9ac0900530d117fc64adc96d5001c714.png";